import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "../Box/Box.mjs";
import { Heading } from "../Heading/Heading.mjs";
import { Secondary } from "../Secondary/Secondary.mjs";
import { Stack } from "../Stack/Stack.mjs";
import { Text } from "../Text/Text.mjs";
import { TextLinkButton } from "../TextLinkButton/TextLinkButton.mjs";
const config = {
  illustrationSize: {
    medium: "medium",
    large: "large"
  },
  positiveIllustration: () => /* @__PURE__ */ jsx(Secondary, { children: "Positive" }),
  negativeIllustration: () => /* @__PURE__ */ jsx(Secondary, { children: "Negative" })
};
const Feedback = ({ title, description, status, illustration, size, action }) => /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Stack, { space: "xxlarge", align: "center", children: [
  renderIllustration(illustrationElement(status, illustration)),
  /* @__PURE__ */ jsxs(Stack, { space: size, children: [
    renderTitle(size, title),
    !!description && renderDescription(description),
    action && /* @__PURE__ */ jsx(Text, { align: "center", children: /* @__PURE__ */ jsx(TextLinkButton, { weight: "regular", onClick: action.onClick, children: action.label }) })
  ] })
] }) });
function renderTitle(size, title) {
  return /* @__PURE__ */ jsx(Heading, { level: "6", align: "center", children: title });
}
function renderDescription(desc) {
  return /* @__PURE__ */ jsx(Text, { tone: "secondary", weight: "medium", children: desc });
}
function illustrationElement(status, illustration) {
  if (illustration) {
    return illustration;
  } else if (status) {
    return illustrationForStatus(status);
  }
  return void 0;
}
function illustrationForStatus(status) {
  switch (status) {
    case "positive":
      return config.positiveIllustration;
    case "negative":
      return config.negativeIllustration;
  }
}
function renderIllustration(illustration) {
  const illustrationProps = {};
  return illustration && illustration(illustrationProps);
}
export {
  Feedback
};
